import supabase from './supabase';

const getProfilePic = async (id) => {
  await supabase.storage.from('usuarios').list();
  const { data, error } = await supabase.storage
    .from('usuarios')
    .list(`${id}/fotos`, {
      limit: 2,
      offset: 0,
      sortBy: { column: 'created_at', order: 'desc' },
    });

  if (data.length) {
    return `${process.env.REACT_APP_STORAGE_URL}/${id}/fotos/${data[0].name}`;
  } else {
    return null;
  }
};

export default getProfilePic;
